function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), React.createElement("path", {
  d: "M380 370h75c31 0 57-26 57-57V86c0-32-25-58-57-58H57C25 28 0 54 0 86v227c0 31 25 57 57 57h208v91c0 16 8 20 19 8zm0 0"
})));